// Polyfills and other global environment setup:
import 'error-cause/auto'
import 'focus-visible'
import '../../_src/javascripts/sharedWithConsole/request-idle-callback-polyfill.ts'
import './utils/crypto-randomuuid-polyfill.ts'

// Error monitoring
import './utils/sentry.ts'

import type { Root } from 'react-dom/client'
import { createRoot } from 'react-dom/client'
// eslint-disable-next-line import/order
import ReactModal from 'react-modal'

import 'tippy.js/animations/shift-away.css'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light.css'
import '../scss/index.scss'

import trackIntercomLoadState from ':/_src/javascripts/sharedWithConsole/trackIntercomLoadState.ts'
import { ready } from '{src}/javascripts/sharedWithConsole/ready.ts'

import { ConsoleWithProfiler } from './routes.tsx'

if (typeof window.ResizeObserver === 'undefined') {
  const { ResizeObserver: Polyfill } = await import('@juggle/resize-observer')
  window.ResizeObserver = Polyfill
}

ready(() => {
  trackIntercomLoadState()
})

const rootElement = document.getElementById('console-root')

// This will hide the rest of the app from the screenreader when any modal is open
if (rootElement) {
  ReactModal.setAppElement(rootElement)
}

// Are we at '/crm2'? Are we at '/crm2/modals.html'?
const isItAlexsDemoPage = window.location.href.includes('/crm2/')

let root: Root | undefined
if (!isItAlexsDemoPage && rootElement) {
  if (!root) root = createRoot(rootElement)
  root.render(<ConsoleWithProfiler />)
}
